import React, { useContext, useEffect, useState } from "react";
import { format } from "date-fns";
import { Button, Spinner } from "react-bootstrap";
import DateRangeSelector from "../../../../components/DatePicker/DateRangeSelector";
import { getDestinationPorts, getOptions, getUpcomingItinerary } from "../../../../api/customer.api";
import { SelectedUserContext } from "../../../../context/selecteduser.context";
import { createEnquiry, searchItinerary, updatePrefrences } from "../../../../api/itinerary.api";
import "./IntineraryForm.scss"
import dayjs from "dayjs";
import { RoundTripIconSvg } from "../../../../assets/svg";
import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
interface ItineraryFormProp {
    itineraryIdsArr: any[],
    setItineraryData:any,
    setItineraryIdsArr?: any,
    cleanPayload: (obj: any) => any,
}
const ItineraryForm: React.FC<ItineraryFormProp> = ({setItineraryData, itineraryIdsArr = [], setItineraryIdsArr, cleanPayload}) => {
    const { selectedUser, existingEnquiry, handleExistingEnquiry } = useContext(SelectedUserContext);
    const [loading, setLoading]= useState(false)
    const [filters, setFilters] = useState({
        destination: "",
        departure: "",
        trip: "",
        cruise: "",
    });
    const [cities, setCities] = useState([]);
    const [destinationCities, setDestinationCities] = useState([]);

    const [cruises, setCruises] = useState([]);
    const [tripType, setTripType] = useState([]);
    const [nights, setNights] = useState([]);
    const [seletctedNights, setSeletctedNights] = useState<any>([]);
    const [dateErr, setDateErr] = useState<any>("");

    const [isSelectDateRange, setIsSelectDateRange] = useState(false);
    const [selectDate, setSelectDate] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    const [appliedFilters, setAppliedFilters] = useState<any>([]);

    const [formatedDateRange, setFormatedDateRange] = useState("");

    useEffect(() => {
        if (existingEnquiry?.id) {
            setFilters({
                destination: existingEnquiry?.enquiryPref?.destination?.id || '',
                departure: existingEnquiry?.enquiryPref?.departure?.id || '',
                trip: existingEnquiry?.enquiryPref?.tripType || '',
                cruise: existingEnquiry?.enquiryPref?.shipId || '',
            })

            setSeletctedNights(existingEnquiry?.enquiryPref?.nightCount || []);
            if (existingEnquiry?.enquiryPref?.startDate && existingEnquiry?.enquiryPref?.endDate) {
                setSelectDate([{
                    startDate: new Date(existingEnquiry?.enquiryPref?.startDate),
                    endDate: new Date(existingEnquiry?.enquiryPref?.endDate),
                    key: "selection",
                }]);
                
                const formattedStartDate = format(new Date(existingEnquiry?.enquiryPref?.startDate), "dd MMM yy");
                const formattedEndDate = format(new Date(existingEnquiry?.enquiryPref?.endDate), "dd MMM yy");
                const formattedDateRange = `${formattedStartDate} - ${formattedEndDate}`;
                setFormatedDateRange(formattedDateRange);
                setDateErr("");
            }
        }
        if(existingEnquiry?.enquiryPref?.departure?.id)
        fetchDestinationData(existingEnquiry?.enquiryPref?.departure?.id)
        fetchData();
    }, [existingEnquiry]);
    
    
    const fetchDestinationData = async (id:string) => {
        try {
            const data = await getDestinationPorts(id);
            if (data.status === 200) {
                setDestinationCities(
                    data?.result?.map((city: any) => ({
                        label: city?.name,
                        value: city?.id,
                    }))
                );
               
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    const fetchData = async () => {
        try {
            const data = await getOptions();
            if (data.status === 200) {
                setCities(
                    data?.result?.ports?.map((city: any) => ({
                        label: city?.name,
                        value: city?.id,
                    }))
                );
                setCruises(
                    data?.result?.ships?.map((cruise: any) => ({
                        label: cruise?.name,
                        value: cruise?.id,
                    }))
                );
                setNights(data?.result?.night_count);
                setTripType(data?.result?.tripType);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    
    const handleOnChange = (ranges: any) => {
        const { selection } = ranges;

        const formattedStartDate = format(new Date(selection.startDate), "dd MMM yy");
        const formattedEndDate = format(new Date(selection.endDate), "dd MMM yy");
        formattedStartDate === formattedEndDate ? setDateErr('Start and end dates must be different') : setDateErr("")
        
        const formattedDateRange = `${formattedStartDate} - ${formattedEndDate}`;
        setFormatedDateRange(formattedDateRange);
        const existingFilterIndex = appliedFilters.findIndex(
            (filter: any) => filter.filterLabel === "Date Range"
        );

        if (existingFilterIndex !== -1) {
            const updatedFilters = [...appliedFilters];
            updatedFilters[existingFilterIndex] = {
                filterLabel: "Date Range",
                value: formattedDateRange.toLocaleString(),
                label: formattedDateRange.toLocaleString(),
            };
            setAppliedFilters(updatedFilters);
        } else {
            setAppliedFilters((prevFilters: any) => [
                ...prevFilters,
                {
                    filterLabel: "Date Range",
                    value: formattedDateRange,
                    label: formattedDateRange,
                },
            ]);
        }
        setSelectDate([selection]);
    };

    const handleSelectNights = (value: string) => {
        setSeletctedNights((prevNights: any) => {
            if (prevNights?.includes(value)) {
                return prevNights.filter((night: any) => night !== value)
            } else {
                return [...prevNights, value]
            }
        })
    }

    const handleSelectedFilters =
        async (option: any, filterName: string) => { 
            const { value, label } = option;
            const existingFilterIndex = appliedFilters.findIndex(
                (filter: any) => filter.filterLabel === filterName
            );
            
            if (existingFilterIndex !== -1) {
                const updatedFilters = [...appliedFilters];
                updatedFilters[existingFilterIndex] = {
                    filterLabel: filterName,
                    value: value,
                    label: label,
                };
                setAppliedFilters([...updatedFilters]);
            } else {
                setAppliedFilters((prevFilters: any) => [
                    ...prevFilters,
                    { filterLabel: filterName, value: value, label: label },
                ]);
            }
            
            setFilters((prevFilters) => ({
                ...prevFilters,
                [filterName]: value,
            }));
            if(filterName=="departure"){
                await fetchDestinationData(value)
                setFilters((prevFilters) => ({
                    ...prevFilters,
                    destination: "",
                }))
            }
        }
        
    const filterAndRearrangeItineraries = (result: any[], selectedItineraryArray: any[]) => {
        const filterSelectedItinerary: any[] = [];
        const filterAvailableItinerary: any[] = [];
        const selectedIdSet = new Set(selectedItineraryArray);

        result.forEach(itinerary => {
          if (selectedIdSet.has(itinerary?.id)) {
            filterSelectedItinerary.push(itinerary);
          } else {
            filterAvailableItinerary.push(itinerary);
          }
        });
        
        const tempArr = filterSelectedItinerary?.map((itinerary: any) => itinerary?.id);
        setItineraryIdsArr([...tempArr]);

        return [...filterSelectedItinerary, ...filterAvailableItinerary];
    };

    const handleSubmit = async () => {
        let payload: any = {
            "customerId": selectedUser?.id,
            "startDate": dayjs(selectDate[0].startDate).format("YYYY-MM-DD"),
            "endDate": dayjs(selectDate[0].endDate).format("YYYY-MM-DD"),
            "departureId": filters.departure,
            "destinationId": filters.destination,
            "tripType": filters.trip,
            "shipId": filters.cruise,
            "nightCount": seletctedNights,
        }

        if (payload.startDate === payload.endDate) {
            payload.startDate = null;
            payload.endDate = null;
        }

        if (!payload.nightCount.length) delete payload.nightCount;
        payload = { ...cleanPayload(payload) };

        setLoading(true);
        if (!existingEnquiry?.id) {
            const data = await createEnquiry(payload);
            handleExistingEnquiry(data?.result);
            if (payload.startDate === payload.endDate) {
                setSelectDate([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
                setFormatedDateRange("");
            }
        }
        else {
            await updatePrefrences(payload, existingEnquiry?.id)
            if (!payload?.startDate && !payload?.endDate && !payload?.departureId && !payload?.destinationId && !payload?.tripType && !payload?.shipId && !payload?.nightCount?.length) {
                const data = await getUpcomingItinerary();
                if (data.status === 200) {
                setItineraryData(data?.result);
                }
                setLoading(false);
                return;
            }
                
            const formattedPayload = {
              ...payload,
              ...(payload?.startDate &&
                payload?.endDate && {
                  startDate: dayjs(payload.startDate).format("YYYY-MM-DD"),
                  endDate: dayjs(payload.endDate).format("YYYY-MM-DD"),
                }),
            };

            const availableItinerary = await searchItinerary(cleanPayload(formattedPayload));
            if (!!availableItinerary?.result?.result?.length) {
                const rearrangedItineraries = filterAndRearrangeItineraries(availableItinerary?.result?.result, itineraryIdsArr);
                setItineraryData(rearrangedItineraries);
            } else setItineraryData([]);
        }
        setLoading(false);
    }

    const handleFormReset = () => { 
        setSelectDate([{ startDate: new Date(), endDate: new Date(), key: "selection" }]);
        setDateErr("");
        setFormatedDateRange("");
        setFilters({ destination: "", departure: "", trip: "", cruise: "" });
        setSeletctedNights([]);
    }

    return (
        <>
          <div className="flex justify-between items-start -mt-2">
            <h3>Check Available Itineraries</h3>
            <span className="cursor-pointer border-b border-b-[#d0566e]" onClick={handleFormReset}>Reset</span>
          </div> 
        <div className="flex flex-col gap-14 itinerary-form">
            <div className="flex flex-col gap-2">
                <div className="flex gap-4">
                <DateRangeSelector
                    issSelectDateRange={isSelectDateRange}
                    handleOnChange={handleOnChange}
                    selectDate={selectDate}
                    setIsSelectDateRange={setIsSelectDateRange}
                    formatedDateRange={formatedDateRange}
                    clx={'input-wrapper w-1/5'}
                />
                <div className="flex flex-col justify-between w-1/5 input-wrapper">
                <CustomSelect onChange={(option) => handleSelectedFilters(option, "departure")}
                    label={"Departure"} options={cities} value={filters?.departure} wantDefault/>
                </div>
                <div className="max-w-[50px] grid items-center">
                <div className="flex justify-center" >
                {/* onClick={handleExchangeDestinationDeparture} */}
                    <RoundTripIconSvg/>
                </div>
                </div>
                <div className="flex flex-col justify-between w-1/5 input-wrapper">
                <CustomSelect onChange={(option) => handleSelectedFilters(option, "destination")}
                    label={"Destination"} options={destinationCities} value={filters?.destination} wantDefault/>
                </div>
                <div className="flex flex-col justify-between w-1/5 input-wrapper">
                <CustomSelect onChange={(option) => handleSelectedFilters(option, "trip")}
                    label={"Trip Type"} options={tripType} value={filters?.trip} wantDefault/>
                </div>
                <div className="flex flex-col justify-between w-1/5 input-wrapper">
                <CustomSelect onChange={(option) => handleSelectedFilters(option, "cruise")}
                    label={"Cruise"} options={cruises} value={filters?.cruise} wantDefault/>
                </div>  
                </div>
                <div className="flex gap-4">
                <span className="w-1/5 text-sm text-[#e33444] whitespace-normal">{dateErr}</span>
                </div> 
                </div>
            <div className="d-flex justify-content-between">
                    <div className="d-flex align-items-center">
                        <span>Select Nights:</span>
                        <nav className="nav nav-pills nav-fill itneries-links">
                            {nights?.map((night: string) => (
                                <span
                                    key={night}
                                    className={`text-center selected-tabs${seletctedNights?.includes(night) ? "-active" : ""
                                        }`}
                                    aria-current="page"
                                    onClick={() => handleSelectNights(night)}
                                >
                                    {night}
                                </span>
                            ))}
                        </nav>
                    </div>
                <div className="itneries-button-check-availibity">
                    <Button
                        onClick={() => handleSubmit()}
                        className="itneries-button-check-availibity-button"
                        disabled={!!dateErr}
                    >
                    {loading && <Spinner animation="border" size="sm" className="mr-3" />}
                        Check Availability
                    </Button>
                </div>
            </div>
        </div>
        </>
        
    )
}
export default ItineraryForm